import { Box, Chip, FormControl, InputLabel, MenuItem, Select, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'

const CustomOptionSelect = ({
  stateKey,
  value,
  options,
  displayLabel,
  setterFn,
  minWidth = 159,
}: {
  stateKey: string
  value: any
  options: any[]
  displayLabel: string
  setterFn: (value: any) => void
  minWidth?: number | string
}) => {
  const theme = useTheme()
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  const handleChange = event => {
    const newValue = event.target.value
    setSelectedValue(newValue)
    setterFn(newValue)
  }

  return (
    // <Box sx={{ minWidth: 150 }}>
    <FormControl fullWidth variant="outlined" sx={{ display: 'flex', alignItems: 'center' }}>
      <InputLabel
        id={`${stateKey}-label`}
        sx={{
          color: theme.palette.mode === 'dark' ? 'rgb(255,255,255,0.5)' : 'rgb(0,0,0,0.5)',
          fontSize: '16px',
          transform: 'translate(9px, 11px) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -10px) scale(0.75)',
          },
          '&.Mui-focused': {
            color: theme.palette.mode === 'dark' ? 'rgb(121 212 255)' : 'black',
          },
        }}
      >
        {displayLabel}
      </InputLabel>
      <Select
        labelId={`${stateKey}-label`}
        id={`${stateKey}-select`}
        value={selectedValue || ''}
        onChange={handleChange}
        label={displayLabel}
        renderValue={selected => (
          <Box sx={{ display: 'flex', alignItems: 'center' }} gap={1}>
            {selected ? (
              <Chip
                size="small"
                style={{
                  backgroundColor: options.find(opt => opt.label === selected)?.color,
                  width: 14,
                  height: 14,
                  borderRadius: '50%',
                }}
              />
            ) : null}
            <Typography variant="subtitle1" noWrap>
              {selected}
            </Typography>
          </Box>
        )}
        sx={{ minWidth: minWidth ?? 150 }}
      >
        {options.map(option => (
          <MenuItem key={option.label} value={option.label}>
            <Chip
              size="small"
              style={{
                backgroundColor: option.color,
                width: 14,
                height: 14,
                borderRadius: '50%',
                marginRight: 8,
              }}
            />
            <Typography variant="subtitle1">{option.label}</Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    // </Box>
  )
}

export default CustomOptionSelect
